import { observable, action, decorate, configure, toJS } from 'mobx';
import {
  API_PRODUCTIMAGES_GET_BYAUCTION_ENDPOINT,
  API_PRODUCTIMAGES_GET_BYLANE_ENDPOINT,
  API_PRODUCTIMAGES_REUPLOAD_ENDPOINT,
} from '../shared/constants';
import { loadData } from './utils';
configure({ enforceActions: 'always' });

class ProductImageStore {
  constructor() {
    // console.log('store called');
    this.initializeProductImagesList();
  }
  initializeProductImagesList = () => {
    this.data = [];
    this.totalItems = 0;
    this.isLoading = true;
  };

  setProperty = (key, value) => {
    this[key] = value;
  };

  getProperty = (key) => {
    return this[key];
  };

  processData = (res) => {
    const {
      data: {
        pagedProductMediaGallery: { items, totalItems },
      },
    } = res;
    this.data = toJS(items);
    this.totalItems = totalItems;
    this.isLoading = false;
  };

  loadProductImagesByAuction = (
    auctionID,
    pageNumber,
    pageSize,
    searchText,
    sortColumn,
    sortDirection,
    mediaGalleryState,
  ) => {
    if (!auctionID) {
      return;
    }

    const params = {
      auctionID,
      pageSize,
      searchParams: searchText,
      pageNumber,
      sortBy: sortColumn,
      sortDirection,
      mediaGalleryState,
    };

    this.isLoading = true;
    loadData(params, API_PRODUCTIMAGES_GET_BYAUCTION_ENDPOINT).then((res) =>
      this.processData(res),
    );
  };

  loadProductImagesByLane = (
    laneID,
    pageNumber,
    pageSize,
    searchText,
    sortColumn,
    sortDirection,
    mediaGalleryState,
  ) => {
    if (!laneID) {
      return;
    }

    const params = {
      laneID,
      pageSize,
      searchParams: searchText,
      pageNumber,
      sortBy: sortColumn,
      sortDirection,
      mediaGalleryState,
    };

    this.isLoading = true;
    loadData(params, API_PRODUCTIMAGES_GET_BYLANE_ENDPOINT).then((res) =>
      this.processData(res),
    );
  };

  reloadProductImage = async (args) => {
    const params = { ...args };
    const res = await loadData(params, API_PRODUCTIMAGES_REUPLOAD_ENDPOINT);
    const results = {
      result: { message: res.data.message, success: res.data.success },
    };
    return results;
  };
}

decorate(ProductImageStore, {
  data: observable,
  getProperty: action,
  initializeProductImagesList: action,
  isLoading: observable,
  loadProductImagesByAuction: action,
  loadProductImagesByLane: action,
  processData: action,
  setData: action,
  setProperty: action,
  totalItems: observable,
  reloadProductImage: action,
});

export default ProductImageStore;
